import {SingleTenantProps} from '../../constants/types';

export const arrayToOptions = (
    groups
) => groups?.map(({id, name}) => ({
  value: id,
  label: name
})) || [];

export const getTenantId = (
    activeTenantName: string,
    tenants: SingleTenantProps[]
) => {
  return tenants.find(({slug}) => slug === activeTenantName)?.id;
};
